import { Plus, X, Coins } from "lucide-react";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { num, mdCell } from "../../lib/richtext";

export const CURRENCIES = ["XOF", "EUR", "USD"];
export const fmtMoney = (v, cur) => `${new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 2 }).format(v)} ${cur}`;
export const financeTotal = (rows) => rows.reduce((s, r) => s + num(r.quantite) * num(r.unitaire), 0);

export const financeToMarkdown = (rows, currency) => {
  if (!rows.length) return "";
  let md = "\n\n## Proposition financière (montants hors taxes)\n\n| Désignation | Quantité | Coût unitaire | Total |\n| --- | --- | --- | --- |\n";
  md += rows.map((r) => `| ${mdCell(r.designation)} | ${r.quantite} | ${fmtMoney(num(r.unitaire), currency)} | ${fmtMoney(num(r.quantite) * num(r.unitaire), currency)} |`).join("\n");
  md += `\n| Total général |  |  | ${fmtMoney(financeTotal(rows), currency)} |`;
  return md;
};

export function FinanceTable({ rows, onChange, currency, onCurrency }) {
  const setCell = (i, k, v) => onChange(rows.map((r, idx) => (idx === i ? { ...r, [k]: v } : r)));
  const total = financeTotal(rows);
  return (
    <div className="mt-4 rounded-2xl border border-slate-200 bg-white p-5" data-testid="cv-finance">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="flex items-center gap-2 font-semibold text-navy"><Coins size={16} className="text-[#0E7C7B]" /> Proposition financière</p>
        <div className="flex items-center gap-2">
          <select value={currency} onChange={(e) => onCurrency(e.target.value)} data-testid="cv-finance-currency" className="h-8 rounded-lg border border-slate-200 bg-white px-2 text-xs text-navy">
            {CURRENCIES.map((c) => <option key={c} value={c}>{c}</option>)}
          </select>
          <Button onClick={() => onChange([...rows, { designation: "", quantite: "1", unitaire: "0" }])} data-testid="cv-finance-add" variant="outline" className="rounded-full border-slate-300 text-xs text-slate-600"><Plus size={13} className="mr-1" /> Ligne</Button>
        </div>
      </div>
      <div className="mt-3 overflow-x-auto">
        <table className="w-full min-w-[560px] text-left text-xs">
          <thead><tr className="border-b border-slate-200 text-slate-500">{["Désignation", "Quantité", "Coût unitaire", "Total", ""].map((h) => <th key={h} className="px-1.5 py-1.5">{h}</th>)}</tr></thead>
          <tbody>{rows.map((r, i) => (
            <tr key={i} data-testid={`cv-finance-row-${i}`} className="border-b border-slate-100">
              <td className="p-1"><Input value={r.designation} onChange={(e) => setCell(i, "designation", e.target.value)} data-testid={`cv-finance-designation-${i}`} className="h-8 text-xs" placeholder="Ex. Honoraires consultant (jour)" /></td>
              <td className="p-1"><Input value={r.quantite} onChange={(e) => setCell(i, "quantite", e.target.value)} data-testid={`cv-finance-qty-${i}`} className="h-8 w-20 text-xs" /></td>
              <td className="p-1"><Input value={r.unitaire} onChange={(e) => setCell(i, "unitaire", e.target.value)} data-testid={`cv-finance-unit-${i}`} className="h-8 w-28 text-xs" /></td>
              <td className="px-1.5 py-1 font-semibold text-navy" data-testid={`cv-finance-total-${i}`}>{fmtMoney(num(r.quantite) * num(r.unitaire), currency)}</td>
              <td className="p-1"><button onClick={() => onChange(rows.filter((_, k) => k !== i))} data-testid={`cv-finance-del-${i}`} className="text-slate-400 hover:text-red-500"><X size={14} /></button></td>
            </tr>
          ))}</tbody>
          <tfoot><tr className="border-t-2 border-slate-300"><td className="px-1.5 py-2 font-bold text-navy" colSpan={3}>Total général (HT)</td><td className="px-1.5 py-2 font-bold text-[#0E7C7B]" data-testid="cv-finance-grand-total">{fmtMoney(total, currency)}</td><td /></tr></tfoot>
        </table>
      </div>
      <p className="mt-2 text-xs text-slate-400">Montants hors taxes. Le tableau est inséré sous la lettre dans les exports PDF et Word.</p>
    </div>
  );
}
